import { render } from "./Skill.vue?vue&type=template&id=0e0c93ac&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"

import "./Skill.vue?vue&type=style&index=0&id=0e0c93ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e0c93ac"

export default script